import React from 'react';
import ReactDOM from 'react-dom/client';
import Recoil from 'recoil';

import App from './components/App';
import './css/index.css';
import './css/theme.css';
import './css/z.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Recoil.RecoilRoot>
      <App />
    </Recoil.RecoilRoot>
  </React.StrictMode>
);